import { TypedDocumentNode, gql } from '@apollo/client';

export type SubmitCompanyKycMutationResponseType = {
  django: {
    submit_kyc_mutation: {
      submited: boolean;
    };
  };
};

export const submitCompanyKycMutation = gql`
  mutation submitCompanyKycMutation {
    django {
      submit_kyc_mutation {
        submited
      }
    }
  }
` as TypedDocumentNode<SubmitCompanyKycMutationResponseType>;
